/**
 * CCAvenue has no browser SDK: it takes an encrypted form POST and replies with
 * a full page. Their own kit navigates the customer to a CCAvenue-branded site,
 * which is exactly what a white-label checkout exists to prevent — so we post
 * into an iframe on our page instead.
 *
 * The customer stays with the merchant, and the card still never touches us.
 */
export function mount({ session, container }) {
  // Cross-origin: we cannot read inside this frame, and do not need to. The
  // outcome arrives at our own return URL and is verified server-side.
  const frame = document.createElement('iframe');
  frame.name = `ccav-${Math.random().toString(36).slice(2)}`;
  frame.title = 'Secure payment';
  frame.setAttribute('allow', 'payment');
  frame.style.cssText = 'width:100%;min-height:520px;border:0;display:block;border-radius:12px;background:#fff';
  container.appendChild(frame);

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = session.action;
  form.target = frame.name;
  form.style.display = 'none';

  for (const [name, value] of Object.entries(session.fields ?? {})) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
  form.remove();

  return () => {
    frame.remove();
  };
}

export default { mount, rendersOwnFields: true, fillsFrame: true };
